import { useMemo, forwardRef } from 'react'
import { Link, LinkProps, matchPath, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ListItem, ListItemProps, ListItemText } from '@mui/material'
import { SvgIconComponent } from '@mui/icons-material'
import { SvgIconComponent as CustomSvgIconComponent } from 'shared/types'
import { paths, theme } from 'config'
import ListItemIcon from './ListItemIcon'

const ListItemLink = ({ icon: Icon, label, to, onClick, ...props }: any) => {
  const { t } = useTranslation()
  const renderLink = useMemo(
    () =>
      forwardRef<any, Omit<LinkProps, 'to'>>((itemProps, ref) => (
        <Link to={to} ref={ref} {...itemProps} />
      )),
    [to]
  )

  const handleClick = (event: any) => {
    if (onClick) {
      onClick(event)
    }
  }

  return (
    <li>
      <ListItem button component={renderLink} onClick={handleClick} {...props}>
        {Icon && (
          <ListItemIcon>
            <Icon />
          </ListItemIcon>
        )}
        {label && (
          <ListItemText
            primary={t(label)}
            primaryTypographyProps={{ color: 'inherit' }}
            sx={{
              color: theme.palette.text.secondary,
            }}
          />
        )}
      </ListItem>
    </li>
  )
}

export interface DrawerItemProps extends Partial<ListItemProps> {
  label?: string
  icon?: SvgIconComponent | CustomSvgIconComponent
  path: string
  to?: string
  onClick?: (event: any) => void
}

const DrawerItem = ({
  path,
  onClick,
  to: toOverride,
  ...props
}: DrawerItemProps) => {
  const { pathname } = useLocation()
  const to = toOverride || path
  const match = matchPath(pathname, { path: to, exact: to === paths.home })

  return (
    <ListItemLink
      to={to}
      onClick={onClick}
      {...props}
      className={`${props.className || ''} ${match ? 'Mui-selected' : ''}`}
    />
  )
}

export default DrawerItem
